import { render } from "./group-builder-workflow.vue?vue&type=template&id=533dd656&scoped=true"
import script from "./group-builder-workflow.vue?vue&type=script&lang=js"
export * from "./group-builder-workflow.vue?vue&type=script&lang=js"

import "./group-builder-workflow.vue?vue&type=style&index=0&id=533dd656&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-533dd656"]])

export default __exports__